// extracted by mini-css-extract-plugin
export default {"question_content_scroll":"AddNewBox_question_content_scroll__Ghg0U","question_title_scroll":"AddNewBox_question_title_scroll__65WwC","active":"AddNewBox_active__dCldZ"};